module.exports = __webpack_public_path__ + "images/emoji/alarm_clock.2844dfc86f45e5ccdd44.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/alarm_clock.png
// module id = eogE
// module chunks = 24